import { AfterViewInit, Component, Inject, Input, TemplateRef, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { catchError, map } from "rxjs/operators";
import { EMPTY, Subscription } from "rxjs";
import { FeaturedClustersService } from "@/core/services/featured-clusters.service";
import { FormControl } from "@angular/forms";
import {
  ClusterDetailsGQL,
  ClusterFieldsFragment,
  DeleteClusterGQL,
} from "@/core/graphql/graphql";
import { AccordionItem } from "@/shared/components/accordion/expandable-panel.component";

@Component({
  selector: 'cosmos-cluster-summary',
  styleUrls: ['./cluster-summary.component.scss'],
  templateUrl: './cluster-summary.component.html',
})
export class ClusterSummaryComponent {
  @ViewChild('isFeaturedSlider') public featuredSlider: TemplateRef<any>;
  @ViewChild('image') public image: TemplateRef<any>;
  @Input() public set cluster(cluster: ClusterFieldsFragment) {
    if (cluster) {
      this._cluster = cluster;
      this.setupFormControl();
    }
  }

  public _cluster: ClusterFieldsFragment;
  public isFeaturedLoading: boolean = false;
  public isFeatured: FormControl;
  public _accordionData: AccordionItem[];
  private readonly _subscription: Subscription = new Subscription();

  public constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: { elementId: number },
    private readonly _featuredClustersService: FeaturedClustersService,
    private readonly _clusterDetailsGql: ClusterDetailsGQL,
    private readonly _deleteClusterGql: DeleteClusterGQL,
  ) {
    this._subscription.add(
      this._featuredClustersService._loadingObservable$
        .subscribe(next => this.isFeaturedLoading = next),
    );

    this._clusterDetailsGql.fetch({ id: this.data.elementId }).pipe(
      catchError(() => {
        return EMPTY;
      }),
    ).subscribe(next => {
      this._cluster = next.data.cluster;
      this.setupFormControl();
      this.setupAccordionData();
    });
  }

  private setupFormControl(): void {
    this._subscription.add(
      this._featuredClustersService.getFeaturedClusters().pipe(
        map((clusters) => clusters.map(cluster => cluster.id)),
      ).subscribe((elementIds: string[]) => {
        this.isFeatured = new FormControl(elementIds.includes(this._cluster.id, 0));
        this.handleFormControl();
      }),
    );
  }

  private handleFormControl(): void {
    if (this.isFeatured) {
      this._subscription.add(
        this.isFeatured.valueChanges.subscribe(next => {
          next
            ? this._featuredClustersService.addFeaturedCluster(this._cluster.id)
            : this._featuredClustersService.removeFeaturedCluster(this._cluster.id);
        }),
      );
    }
  }

  public setupAccordionData(): void {
    this._accordionData = [
      { name: 'Image', value: '', template: this.image, isImage: true },
      { name: 'Name: ', value: this._cluster.name },
      { name: 'Private: ', value: this._cluster.isPrivate },
      { name: 'ID: ', value: this._cluster.id },
      { name: 'Followers Count: ', value: this._cluster.followersCount },
      { name: 'Owner ID: ', value: this._cluster.ownerId },
      { name: 'Is featured: ', value: '', template: this.featuredSlider },
    ];
  }
}
